import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import styles from './Kinoklubb.module.css';
import type { CSSProperties } from "react";
import { locale } from "@locale";
import { formatLocaleStringWithLink } from "src/lib/locale/helpers";

//#region [Props]
type KinoklubbProps = {
  className?: string;
  style?: CSSProperties;
};
//#endregion

//#region [Component]
export default function Kinoklubb(t0) {
  const $ = _c(6);
  const {
    className,
    style
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(styles.SKinoklubb, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = formatLocaleStringWithLink(locale.kinoklubb.showsbanner, {
      linkClassName: styles.SKinoklubbLink
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== style || $[4] !== t1) {
    t3 = <div className={t1} style={style}>{t2}</div>;
    $[3] = style;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
//#endregion

//#region [Styles]
//#endregion